export const ACTIVATION_PROMPTS = [
  {
    id: 'opportunities-risks',
    label: 'Top opportunities',
    text: 'Review my financial picture. What are the top 3 opportunities or risks I should focus on first?',
    icon: 'target',
  },
  {
    id: 'cash-flow',
    label: 'Cash flow moves',
    text: 'Look at my income, spending, and balances. What should I change this month to improve cash flow?',
    icon: 'trend',
  },
  {
    id: 'thirty-day-plan',
    label: 'Build a 30-day plan',
    text: 'Build a 30-day money plan from my accounts, debts, goals, and profile. What are my first 3 actions?',
    icon: 'calendar',
  },
];

export function getActivationStep({
  hasProfile,
  hasPlaidConnection,
  hasSentMessage,
  plaidSkippedThisSession,
}) {
  if (hasSentMessage) return 'complete';
  if (!hasProfile) return 'profile';
  if (hasPlaidConnection || plaidSkippedThisSession) return 'prompts';
  return 'connect';
}

export function shouldShowActivation({ step }) {
  return step === 'connect' || step === 'prompts';
}

export function getPromptCards() {
  return ACTIVATION_PROMPTS;
}
